<template>
  <DropdownField
    id="institution-list"
    name="transactSSO.institutionId"
    optionLabel="name"
    optionValue="id"
    :options="institutions"
    :placeholder="translate(`${LOCALE_PREFIX}.form.transactSSOInstitutionPlaceholder`)"
    :required="true"
    :disabled="!editMealPlan"
  />
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { useMealPlanStore } from '../../../../../../../routes/stores/use-meal-plan-store';
import { useFinancialConfigStore } from '../../../../../../../routes';
import { SitesLocalePrefix } from '../../../../../../../enums';
import type { Institution } from '@compassdigital/sdk.typescript/interface/mealplan';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;
const financialConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(financialConfigStore);
const mealPlanStore = useMealPlanStore();
const { institutionList } = storeToRefs(mealPlanStore);

// Transform the institution list to ensure it has 'id' and 'name' fields
const institutions = computed(() => {
  return institutionList.value.map((institution: Institution) => ({
    id: institution.InstitutionId,
    name: institution.Name,
  }));
});
</script>
